var exports = {
  "q5": "AppLayout.module__appLayout___aEZaLW",
  "Xp": "AppLayout.module__appLayoutStandalone___aEZaLW",
  "Tv": "AppLayout.module__withCompanion___aEZaLW",
};

module.exports = exports;
